import { html, LitElement } from 'lit-element';
import { createCorrectnessText, getPercentage } from './utils.js';

/**
 * @element header-block-multiple-choice
 * @prop {Object} session - session
 * @prop {Object} item - Item
 * @prop {Object} studentsNumber - students Number
 * @prop {Number} studentsAnsweredNr - The number of all the student that answered the question
 */
export class HeaderBlockMultipleChoice extends LitElement {
  static get properties() {
    return {
      item: { type: Object, attribute: false },
      studentsNumber: { type: Number, attribute: false },
      studentsAnsweredNr: { type: Number, attribute: false },
      session: { type: Number, attribute: false },
    };
  }

  createRenderRoot() {
    return this;
  }

  // eslint-disable-next-line class-methods-use-this
  renderSelectedChoices() {
    const { data } = this.session || {};
    const { choices, keyMode, element } = this.item || {};

    // TODO
    if (element !== 'multiple-choice') {
      return null;
    }

    const sessionPart = data && data[0];

    const { value } = sessionPart || {};

    if (!choices || !value) return '';

    const charCode = keyMode === 'numbers' ? 49 : 65;

    const valuesToRender = (choices || []).reduce((acc, choice, index) => {
      if (value.indexOf(choice.value) >= 0) {
        acc.push(index);
      }

      return acc;
    }, []);

    const selectedChoices = valuesToRender.map(index => ({
      ...choices[index],
      indicator: String.fromCharCode(index + charCode),
    }));

    return html`
      <div class="header-correct-response">
        <div class="row">
          ${selectedChoices.map(response => {
            const correctnessClass = response.correct ? 'correct' : 'incorrect';

            return html`<div
              class="header-correct-response-selection ${correctnessClass}"
            >
              ${response.indicator}
            </div>`;
          })}
        </div>
        <div class="header-correct-response-value">
          ${selectedChoices.map(
            (response, index) => html`
              <div>
                <math-rendering-element
                  .label=${response.label}
                ></math-rendering-element>
                ${index < selectedChoices.length - 1 ? ', ' : ''}
              </div>
            `
          )}
          <div class="header-correct-response-value-overflow"></div>
          <div class="header-correct-response-value-bottom-overflow"></div>
        </div>
      </div>
    `;
  }

  _openRationale(correctness) {
    const content = html`<rationale-modal-multiple-choice
      .response=${{
        sessionData: this.session.data ? this.session.data[0] : '',
        item: this.item,
        correctness,
      }}
    ></rationale-modal-multiple-choice>`;

    window.dispatchEvent(
      new CustomEvent('classroom-tool-live-open-modal', {
        detail: {
          modalContent: content,
          modalType: 'rationale-modal-multiple-choice',
          modalTitle: html`<p><strong>Rationale</strong></p>`,
        },
      })
    );
  }

  _openDetails() {
    const studentsNr = this.studentsNumber || 0;
    const studentsAnsweredNr = this.studentsAnsweredNr || 1;

    const content = html`<view-details-modal-multiple-choice
      .response=${{
        sessionData: this.session.data ? this.session.data[0] : '',
        item: this.item,
        studentsNr,
        studentsAnsweredNr,
      }}
    ></view-details-modal-multiple-choice>`;

    window.dispatchEvent(
      new CustomEvent('classroom-tool-live-open-modal', {
        detail: {
          modalContent: content,
          modalType: 'view-details-modal-multiple-choice',
          modalTitle: html`<p><strong>Details</strong></p>`,
        },
      })
    );
  }

  render() {
    const studentsNr = this.studentsNumber || 0;
    const percentage = getPercentage(
      this.studentsNumber,
      this.studentsAnsweredNr
    );
    const { data, autoScore, correctnessGroup } = this.session || {};
    const { points } = autoScore || {};
    const { choiceMode, choices } = this.item || {};
    const correctness = correctnessGroup || 'unanswered';
    const correctnessText = createCorrectnessText(points);

    const selectedChoices = this.renderSelectedChoices();

    if (choiceMode && choiceMode === 'radio') {
      return html` <div class="header-block">
        <div class="block">
          ${selectedChoices ||
          html`<div class="header-correct-response-no-answer">No Answer</div>`}

          <div class="more">
            ${data && data.length && autoScore
              ? html`<button class="more-button" @click=${this._openDetails}>
                  <span>View Details</span>
                </button>`
              : html`<div></div>`}
            ${data && data.length
              ? html`<button class="more-button" @click=${this._openRationale}>
                  <span>Rationale</span>
                </button>`
              : html`<div></div>`}
          </div>
        </div>

        <div class="block header-students-number">
          ${studentsNr} Student${studentsNr === 1 ? '' : 's'} (${percentage}%)
        </div>
      </div>`;
    }

    const headerChoices = (choices || [])
      .reduce((acc, choice) => {
        if (
          (correctness === 'correct' && choice.correct) ||
          (correctness === 'incorrect' && !choice.correct)
        ) {
          acc.push(String.fromCharCode(65 + choices.indexOf(choice)));
        }

        return acc;
      }, [])
      .join(', ');

    return html` <div class="header-block">
      <div class="block">
        <div class="header-correct-response">
          <div class="header-correct-response-selection ${correctness}">
            ${correctnessText}
          </div>
          ${correctness === 'correct' || correctness === 'incorrect'
            ? html`<div class="header-correct-answer">${headerChoices}</div>`
            : html`<div></div>`}
        </div>

        <div class="more">
          ${correctness === 'correct'
            ? html` <button class="more-button" @click=${this._openDetails}>
                <span>View Details</span>
              </button>`
            : html` <div></div>`}
          ${correctness === 'correct' || correctness === 'incorrect'
            ? html` <button
                class="more-button"
                @click=${() => this._openRationale(correctness)}
              >
                <span>Rationale</span>
              </button>`
            : html` <div></div>`}
        </div>
      </div>

      <div class="block header-students-number">
        ${studentsNr} Student${studentsNr === 1 ? '' : 's'} (${percentage}%)
      </div>
    </div>`;
  }
}

export default HeaderBlockMultipleChoice;
